import React from "react";
import {
  Box,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  IconButton,
  Stack,
} from "@mui/material";
import { AddCircle, Delete } from "@mui/icons-material";

const LineItemsTable = ({
  lineItems,
  isEditing,
  grandTotal,
  colors,
  gstEnabled,
  onLineItemChange,
  onAddItem,
  onRemoveItem,
}) => {
  return (
    <>
      <Box p={2} display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h6" color={colors.greenAccent[500]}>
          Invoice Items
        </Typography>
        {isEditing && (
          <Button
            startIcon={<AddCircle />}
            size="small"
            onClick={onAddItem}
            color="secondary"
          >
            Add Item
          </Button>
        )}
      </Box>

      <TableContainer sx={{ maxHeight: 400 }}>
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell width="40%">Description</TableCell>
              <TableCell width="10%" align="center">Qty</TableCell>
              <TableCell width={gstEnabled ? "25%" : "40%"} align="center">
                Total Amount
                {gstEnabled && (
                  <>
                    <br />
                    <small>(Inc. Tax)</small>
                  </>
                )}
              </TableCell>
              {gstEnabled && (
                <TableCell width="15%" align="center">Tax %</TableCell>
              )}
              {isEditing && <TableCell width="10%">Action</TableCell>}
            </TableRow>
          </TableHead>
          <TableBody>
            {lineItems.map((item, index) => (
              <TableRow key={item.id}>
                <TableCell>
                  {isEditing ? (
                    <TextField
                      value={item.description}
                      onChange={(e) =>
                        onLineItemChange(index, "description", e.target.value)
                      }
                      fullWidth
                      variant="standard"
                      InputProps={{ disableUnderline: true }}
                    />
                  ) : (
                    <Typography variant="body2">{item.description}</Typography>
                  )}
                </TableCell>
                <TableCell align="center">
                  {isEditing ? (
                    <TextField
                      value={item.qty}
                      type="number"
                      onChange={(e) =>
                        onLineItemChange(index, "qty", e.target.value)
                      }
                      fullWidth
                      inputProps={{ style: { textAlign: "center" } }}
                      variant="standard"
                    />
                  ) : (
                    item.qty
                  )}
                </TableCell>
                <TableCell align="center">
                  {isEditing ? (
                    <TextField
                      value={item.inclusiveAmount}
                      type="number"
                      onChange={(e) =>
                        onLineItemChange(index, "inclusiveAmount", e.target.value)
                      }
                      fullWidth
                      inputProps={{
                        style: { textAlign: "center", fontWeight: "bold" },
                      }}
                      variant="standard"
                    />
                  ) : (
                    <Typography fontWeight="bold">
                      ₹{item.inclusiveAmount}
                    </Typography>
                  )}
                </TableCell>
                {gstEnabled && (
                  <TableCell align="center">
                    <Typography variant="caption" color="textSecondary">
                      {item.taxRate}%
                    </Typography>
                  </TableCell>
                )}
                {isEditing && (
                  <TableCell>
                    <IconButton
                      size="small"
                      color="error"
                      onClick={() => onRemoveItem(index)}
                    >
                      <Delete fontSize="small" />
                    </IconButton>
                  </TableCell>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Box
        p={2}
        borderTop={`1px solid ${colors.grey[700]}`}
        bgcolor={colors.primary[600]}
      >
        <Stack direction="row" justifyContent="flex-end" spacing={4} alignItems="center">
          <Typography>Grand Total:</Typography>
          <Typography variant="h4" color={colors.greenAccent[500]} fontWeight="bold">
            ₹ {grandTotal}
          </Typography>
        </Stack>
      </Box>
    </>
  );
};

export default LineItemsTable;